import { formatMoney } from '@mevaser/shared'
import { Alert, Button } from '@mevaser/ui'

/**
 * Shown when a purchase order is marked Paid but the payments recorded against
 * it don't cover the total (t1201). The Payment status is only a label, so this
 * is a warning, never a block; `onRecord` offers to record the payment now.
 */
export function UnpaidOrderWarning({
  owedCents,
  onRecord,
}: {
  owedCents: number
  onRecord?: () => void
}) {
  return (
    <Alert tone="warning" title="No payment recorded">
      <p>
        Marking an order Paid doesn't record a payment — {formatMoney(owedCents)} is still owed.
      </p>
      {onRecord ? (
        <Button type="button" variant="secondary" size="sm" className="mt-2" onClick={onRecord}>
          Record payment
        </Button>
      ) : null}
    </Alert>
  )
}
